<template>
    <a-layout style="height: 100%;">
      <a-layout-header>
        <a-row>
          <a-col span="8">
            <a-breadcrumb class="breadcrumb">
              <a-breadcrumb-item :key="index" v-for="(item, index) in breadcrumbList">
                <a-icon style="margin-right: 10px;" type="home" v-if="index === 0"/>
                <router-link :to="{name: item.name}">{{ item.text }}</router-link>
              </a-breadcrumb-item>
            </a-breadcrumb>
          </a-col>
          <a-col class="actions" span="16" style="text-align: right">
            <a-space :size="30">
              <span v-if="telephone">
                  <a-icon type="phone"/> {{ telephone }}
              </span>
              <a @click="appDownload"><a-icon type="android"/> Android</a>
              <a @click="openIncome"><a-icon type="pay-circle"/> 费用</a>
              <a @click="openHelper"><a-icon type="question-circle"/> 帮助</a>
              <a @click="openUcenter">
                <a-icon type="user"/> 个人中心
              </a>
              <a @click="logout">
                <a-icon type="logout"/> 退出
              </a>
            </a-space>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout-content>
        <router-view/>
        <UseElectron ref="useElectron"/>
      </a-layout-content>
    </a-layout>
</template>

<script>
    import api from "../utils/api";
    import auth from "../utils/auth";
    import func from "../utils/func";
    import layout from "../store/layout";
    import UseElectron from "../comps/UseElectron";

    export default {
        name: "Index",
        components: {UseElectron},
        data() {
            return {
                telephone: "",
                menuConfig: []
            }
        },
        computed: {
            selectKey() {
                return layout.state.selectKey;
            },
            breadcrumbList() {
                return layout.state.breadcrumbList;
            }
        },
        mounted() {
            this.$refs.useElectron.open(false);
            this.$router.options.routes[0].children
                .forEach((route) => {
                    func.hasMetaTitle(route) &&
                    this.menuConfig.push({
                        text: route.meta.title,
                        icon: route.meta.icon,
                        name: route.name,
                    });
                });
            this.telephone = process.env.VUE_APP_TELEPHONE;
        },
        methods: {
            logout() {
                auth.logout().then(() => {
                    this.$router.push({name: "Login"});
                });
            },
            openHelper() {
                window.open(process.env.VUE_APP_HELPER_URL, "_blank");
            },
            openIncome() {
              this.$router.push({name: "UCenter.Income"});
            },
            openUcenter() {
              this.$router.push({name: "UCenter"});
            },
            appDownload() {
                window.open(api.v1.app.grapherAndroid(), "_blank");
            },
        }
    };
</script>

<style lang="less" scoped>
    .ant-layout-header {
        z-index: 998;
        padding: 0 22px;
        height: 54px;
        line-height: 54px;
        background: #fff;
        box-shadow: 0 1px 5px 5px #dedede;

        .breadcrumb {
            margin: 17px 0;
        }

        .actions {
            a {
                color: rgba(0, 0, 0, 0.65);
            }

            span {
                cursor: pointer;
            }
        }
    }

    .ant-layout-sider {
        z-index: 999;
        box-shadow: 1px 0 5px 5px #dedede;

        .logo {
            padding: 12px 0;
            text-align: center;

            img {
                height: 30px;
            }
        }

        .ant-menu {
            border-right: none;
        }
    }

    .ant-layout-content {
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>
